import bikeAnalyticsReducer from "./reducer";
import saga from "./saga";

export default function analyticsModule() {
  return {
    id: "bikeAnalyticsReducer",
    reducerMap: {
      bikeAnalyticsReducer
    },
    sagas: [saga],
    retained: true
  };
}
